import { Observable } from 'rxjs';
import Paginate from '../interfaces/paginate';
import CropChangePlan from '../interfaces/crop-change-plan';
import { HttpClient, ListParams } from './http-client';

export class CropChangePlanService extends HttpClient {
  index(
    farmId: string,
    season: string,
    params: ListParams
  ): Observable<Paginate<any>> {
    return this.get<Paginate<any>>(
      `/api/farms/${farmId}/season/${season}/crop-change-plan`,
      params
    );
  }

  store(
    farmId: string,
    cropChangePlan: CropChangePlan
  ): Observable<CropChangePlan> {
    return this.post<CropChangePlan>(
      `/api/farms/${farmId}/crop-change-plan`,
      cropChangePlan
    );
  }

  show(farmId: string, id: string): Observable<CropChangePlan> {
    return this.get<CropChangePlan>(
      `/api/farms/${farmId}/crop-change-plan/${id}`
    );
  }

  showStatic(
    farmId: string,
    id: string,
    params: {
      fieldIds?: string[];
    }
  ): any {
    return this.get(
      `/api/farms/${farmId}/crop-change-plan/${id}/static`,
      params
    );
  }

  destroy(farmId: string, id: string): Observable<CropChangePlan> {
    return this.delete<CropChangePlan>(
      `/api/farms/${farmId}/crop-change-plan/${id}`
    );
  }

  getAvailableSeasons(farmId: string, season: string): any {
    return this.get(
      `/api/farms/${farmId}/season/${season}/crop-change-plan/available-seasons`
    );
  }

  productCategoriesWithTypes(farmId: string): any {
    return this.get(
      `/api/farms/${farmId}/crop-change-plan/product-categories-with-types`
    );
  }

  getUniqueProducts(farmId: string, params: ListParams): any {
    return this.get(
      `/api/farms/${farmId}/crop-change-plan/unique-products`,
      params
    );
  }

  exportPlanXls(farmId: string, season: string) {
    return this.export(
      `/api/farms/${farmId}/season/${season}/crop-change-plan/excel`
    );
  }
}
